import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { calculateTotalRow, checkForTotalColumn, columnsObj } from "./data";
import { datatypes, deleteTableColumn } from "data/globalData";
import { Badge, Button, Stack, Tab, Tabs, TextField, Typography } from "@mui/material";
import { AddRounded, EditRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";
import { WhiteBgBox, TotalBox } from "../../CostingDetails/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { AuthState } from "context/AuthContext";
import { channelTypes, wearHouses } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { set } from "lodash";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

const ChannelWarehouseSplitTable = ({
	rows,
	setRows,
	totalRow,
	setTotalRow,
	mode = "" || "create" || "edit",
	editMode = false,
	setEditMode = () => {},
	handleSave = () => [],
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();

	const defTableColumns = [
		{
			...columnsObj.size,
			...colStyle,
			minWidth: 120,
			headerName: columnsObj.size.name,
			field: columnsObj.size.key,
			editable: true,
			colSpan: (value, row) => {
				if (checkForTotalColumn(row)) {
					return 1;
				}
				return undefined;
			},
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...columnsObj.qty_percent,
			editable: true,
			...colStyle,
			headerName: columnsObj.qty_percent.name,
			field: columnsObj.qty_percent.key,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...columnsObj.qty,
			field: columnsObj.qty.key,
			headerName: columnsObj.qty.name,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
	];

	const [tableColumnsState, setTableColumnsState] = useState([]);
	const [rowsCopy, setRowsCopy] = useState(rows ? [...rows] : []);
	const [deletedRowIds, setDeletedRowIds] = useState([]);

	const [sizeToAdd, setSizeToAdd] = useState("");

	const [activeChannel, setActiveChannel] = useState(channelTypes.EBO.key);
	const [activeWarehouse, setActiveWarehouse] = useState(wearHouses.GGN.key);

	const defaultRow = tableColumnsState?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	useEffect(() => {
		setTableColumnsState([...defTableColumns]);
		setTotalRow(calculateTotalRow(rows));
	}, []);

	const handleChannelChange = (channel) => {
		setActiveChannel(channel);
	};

	const handleRegionChange = (wh) => {
		setActiveWarehouse(wh);
	};

	const handleAddRowClick = () => {
		let newRow = { ...defaultRow };
		newRow["id"] = new Date().valueOf();
		newRow["is_new"] = true;
		newRow["created_by"] = user.email;
		newRow[columnsObj.channel.key] = activeChannel;
		newRow[columnsObj.warehouse.key] = activeWarehouse;
		newRow[columnsObj.size.key] = sizeToAdd;
		setRows((prev) => [...prev, newRow]);
		setSizeToAdd("");
	};
	function handleDeleteRowClick(rowToDelete) {
		setRows((prev) => {
			const newRows = prev.filter((row) => row.id !== rowToDelete.id);
			setDeletedRowIds((prev) => [...prev, rowToDelete.id]);
			setTotalRow(calculateTotalRow(newRows));
			return newRows;
		});
	}
	const processRowUpdate = (newRow, OldRow) => {
		let correct = true;
		tableColumnsState?.forEach((col) => {
			if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key)
				if (isNaN(newRow[col.key])) correct = false;
		});
		console.log(correct, "sdmnfbnsdfmsd");

		if (correct) {
			// const value = roundDecimalValueUptoTwoDigit(newRow[columnsObj.recieved_qty.key] - newRow[columnsObj.order_qty.key]);
			let updatedNewRow = {
				...newRow,
				// [columnsObj.difference_qty.key]: value,
				is_updated: true,
				last_updated_by: user.email,
			};
			setRows((prev) => {
				let newRows = prev.map((row) => {
					if (row.id === updatedNewRow.id) return updatedNewRow;
					else return row;
				});
				setTotalRow(calculateTotalRow(newRows));
				return newRows;
			});
			return updatedNewRow;
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleCancelEditClick = () => {
		setRows(rowsCopy);
		setDeletedRowIds([]);
		setEditMode(false);
	};
	const handleEditClick = () => {
		setEditMode(true);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const result = await handleSave(rows, deletedRowIds);
			if (result) {
				setRows(result);
				setRowsCopy(result);
				setDeletedRowIds([]);
				setEditMode(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Stack spacing={2}>
			<Box display="flex" justifyContent="space-between" pt={1} pb={1}>
				<Typography variant="h6"> Channel Warehouse Split </Typography>
				<Box display="flex" columnGap="5px">
					{mode === "create" ? (
						<></>
					) : mode === "edit" ? (
						<>
							{editMode ? (
								<>
									<Button variant="outlined" size="small" onClick={handleCancelEditClick}>
										Cancel Edit
									</Button>
									<Button variant="contained" size="small" onClick={handleSaveClick}>
										Save
									</Button>
								</>
							) : (
								<Button variant="contained" size="small" onClick={handleEditClick} startIcon={<EditRounded />}>
									Edit
								</Button>
							)}
						</>
					) : (
						<></>
					)}
				</Box>
			</Box>

			<Box display="flex" width="100%">
				<Stack width="80%" spacing={2}>
					<Box display="flex" columnGap="10px" alignItems="center">
						<Typography sx={{ width: "80px" }}>Channels</Typography>
						<Tabs
							textColor="inherit"
							variant="standard"
							value={activeChannel}
							onChange={(e, val) => handleChannelChange(val)}
							sx={{
								width: "100%",
								boxShadow: "inset 0 -1px 0 0 #E6ECF0",
								border: `1px solid ${grey[200]}`,
								// [`& .${tabsClasses.indicator}`]: {
								// 	backgroundColor: "white",
								// },
							}}>
							{Object.values(channelTypes)?.map((row) => {
								return (
									// <Badge color="secondary" badgeContent="0">
									<Tab label={row?.name} value={row.key} sx={{ overflow: "visible" }} />
									// </Badge>
								);
							})}
						</Tabs>
					</Box>
					<Box display="flex" columnGap="10px" alignItems="center">
						<Typography sx={{ width: "80px" }}>Wearhouses</Typography>
						<Tabs
							textColor="inherit"
							variant="scrollable"
							value={activeWarehouse}
							onChange={(e, val) => handleRegionChange(val)}
							sx={{
								width: "100%",
								boxShadow: "inset 0 -1px 0 0 #E6ECF0",
								border: `1px solid ${grey[200]}`,
								// [`& .${tabsClasses.indicator}`]: {
								// 	backgroundColor: grey[600],
								// },
							}}>
							{Object.values(wearHouses)?.map((row) => {
								return (
									// <Badge color="secondary" badgeContent="0">
									<Tab label={row?.name} value={row.key}></Tab>
									// </Badge>
								);
							})}
						</Tabs>
					</Box>

					<DataGrid
						rows={
							rows
								? [
										...rows.filter(
											(row) =>
												row?.[columnsObj.channel.key] === activeChannel &&
												row?.[columnsObj.warehouse.key] === activeWarehouse
										),
										totalRow,
								  ]
								: []
						}
						getRowId={(row) => row.id}
						columns={[
							...tableColumnsState,
							deleteTableColumn(
								handleDeleteRowClick,
								(row) => (mode !== "create" && !editMode) || checkForTotalColumn(row)
							),
						]}
						sx={{
							width: "100%",
							// maxHeight: 250,
							"& .MuiDataGrid-row": {
								cursor: "pointer",
							},
							"& .MuiDataGrid-row:hover": {
								backgroundColor: "transparent",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								background: grey[400],
								textTransform: "uppercase",
							},
							"& .MuiDataGrid-cell": {
								padding: 0,
							},
						}}
						density="compact"
						disableRowSelectionOnClick
						pagination={false} // Remove footer
						hideFooter={true}
						showCellVerticalBorder
						showColumnVerticalBorder
						isCellEditable={({ row }) => (mode === "create" || editMode) && !checkForTotalColumn(row)}
						processRowUpdate={processRowUpdate}
						autoHeight
					/>
				</Stack>

				<Stack width="16%" spacing={1} p={1} border={`1px solid ${grey[300]}`} borderRadius="4px" ml={2} height="fit-content">
					<Typography variant="body1">Add Size</Typography>
					<TextField size="small" fullWidth value={sizeToAdd} onChange={(e) => setSizeToAdd(e.target.value)} />
					<Button
						sx={{ margin: "22px 10px 0 10px" }}
						variant="contained"
						onClick={handleAddRowClick}
						size="small"
						disabled={!!!sizeToAdd || (mode !== "create" && !editMode)}>
						Add
					</Button>
				</Stack>
			</Box>
		</Stack>
	);
};

export default ChannelWarehouseSplitTable;
